export default {
  // names must coincide with component names in src/pages
  index: "/",
  customers: "/#customers",
  eula: "/eula",
  dpa: "/dpa",
  securitySchedule: "/security-schedule",
  solutions: "/solutions",
  howItWorks: "/how-it-works",
  about: "/about",
  privacyPolicy: "/privacy-policy",
  news: {
    contentRequestsSignUp: "/news/content-requests-announcement#signup",
  },
  signIn: "https://app.socialie.com/log-in",
  requestDemo: "/request-demo",
}
